export default __webpack_public_path__ + "static/media/Q7_1_resized.8f0f6274.jpg";